var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 77,
    viewBox: "0 0 95 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H91C93.2091 0 95 1.79086 95 4V73C95 75.2091 93.2091 77 91 77H4C1.79086 77 0 75.2091 0 73V4Z",
    fill: "#020C41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4167 58.7718C46.0501 59.1375 46.7686 59.33 47.5 59.33C48.2314 59.33 48.9499 59.1375 49.5833 58.7718L64.1667 50.4384C64.7995 50.0731 65.325 49.5478 65.6907 48.9152C66.0564 48.2826 66.2492 47.5649 66.25 46.8343V30.1676C66.2492 29.4369 66.0564 28.7193 65.6907 28.0867C65.325 27.4541 64.7995 26.9288 64.1667 26.5634L49.5833 18.2301C48.9499 17.8644 48.2314 17.6719 47.5 17.6719C46.7686 17.6719 46.0501 17.8644 45.4167 18.2301L30.8333 26.5634C30.2005 26.9288 29.675 27.4541 29.3093 28.0867C28.9436 28.7193 28.7507 29.4369 28.75 30.1676V46.8343C28.7507 47.5649 28.9436 48.2826 29.3093 48.9152C29.675 49.5478 30.2005 50.0731 30.8333 50.4384L45.4167 58.7718Z",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 59.3333V38.5",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3516 28.084L47.4974 38.5007L65.6432 28.084",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.125 22.3965L56.875 33.1257",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/box-icon.394d2c145b2b502464270e9a5adf7d0b.svg";
export { ForwardRef as ReactComponent };